// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c2f59d79f129cb64b56a","655":"aece3fc8d93bd72f0b9b"}[chunkId] + ".js";
};